import App from './App.vue'
import router from './router'
import VueCookie from 'vue-cookie'
import store from './store';
import { Icon } from 'vant';
import VueClipboard from 'vue-clipboard2';  // 剪切板功能

import rem from "./utils/rem.js";
rem();
import Vconsole from 'vconsole';
if (process.env.NODE_ENV != "production") {
    new Vconsole();
}
//  new Vconsole();

import animated from 'animate.css'; //引入动画库
import XesLoggerSDK from "@xes/xes_fe_log";
if (process.env.NODE_ENV == "production") {
  window.logCommonParams = {
    eventid: "web-kmf-hd", //业务自定义的事件字段 例如 huatuoweb
    page: "web-kmf-hd",
  };
  Vue.use(XesLoggerSDK, {
    cacheUploader: {
      interval: 5000,
      batch: 5,
    },
    common: window.logCommonParams,
    param: {},
    clickMsg: {
      open: true,
    },
    // 是否自动上报展现日志开关，如果自动上报需要把展现日志必备参数设置到window.courseDatanSerach上，如果不自动上报，则可以在业务想要的地方使用loadMsg方法自主上报展现日志
    loadMsg: {
      open: true,
    },
    hashchange: {
      open: false,
      pvid: "hash",
      loadParam: {
        //   'index': {
        //     event_properties: {
        //       'event_type': 'pv',
        //       'event_id': 'APP',
        //       '1111111': '22222'
        //     }
        //   },
        //   'DMP': {
        //     event_properties: {
        //       'event_type': 'pv',
        //       'event_id': 'DMP',
        //       '1111111': '22222'
        //     }
        //   },
        //   'path/a': { 'key1': 'zzz' }
      },
    },
    network: {
      open: true,
      sample: 1,
    },
    runtime: {
      open: true,
      sample: 1,
    },
    resource: {
      open: true,
      sample: 1,
    },
    performance: {
      open: true,
      sample: 1,
    },
    vue: {
      errorHandler: true, //vue可以开启，react需要删除
    },
    trace: {
      open: false,
    },
    traceFilter: ["api.kmf.com"],
    appid: {
      // 正式环境
      "hd.kmf.com": {
        appid: "1004143",
        appkey: "ff133dd59130051dd77314af95273794",
      },
      "hd.qz100.com": {
        appid: "1004143",
        appkey: "ff133dd59130051dd77314af95273794",
      },
      "business.kmf.com": {
        appid: "1004143",
        appkey: "ff133dd59130051dd77314af95273794",
      },
      //   'test-vue.qz100.com': {
      //     appid: '1004143',
      //     appkey: 'ff133dd59130051dd77314af95273794'
      //   }
    },
  });
  Vue.prototype.$reportLog = function(type, data) {
    Vue.prototype.$xesLogger.instantUploader(
      Object.assign(data, { type }),
      "c",
      "js"
    );
  };
} else {
  Vue.prototype.$reportLog = function(type, data) {
    //非正式环境日志
    return;
  };
}



Vue.use(animated);
Vue.use(Icon);
Vue.use(VueClipboard);



import '@/components'; // 引入全局注册的组件
//注入有赞UI
import '@/plugins/vant.js';
//注入自定义指令
import '@/plugins/directive.js';
//注入神策
import kmfSensors from '@/plugins/kmfsensors.js';
// axios拦截器
import { registerInterceptor } from '@/utils/http';
// 导航守卫
import guard from '@/utils/guard';



Vue.prototype.$http = axios;
Vue.prototype.$cookie = VueCookie;
Vue.prototype.$kmfSensors = kmfSensors;

//设置meta
import Meta from 'vue-meta'
Vue.use(Meta);

// 进入路由前校验
router.beforeEach((to, from, next) => {
    guard(to, from, next);

})

Vue.config.productionTip = false

registerInterceptor();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
